const result49Description = () => {
  return (
    <span>
      As{" "}
      <a
        href="https://www.epicurious.com/expert-advice/anita-lo-cookbook-is-excuse-to-break-up-with-your-significant-o-article"
        target="_blank"
        rel="noreferrer"
        style={{ textDecoration: "none", color: "#E4503B" }}>
        our reviewer noted
      </a>
      , books about cooking for one can feel preachy and too concerned with
      empowerment, but this one is just fun (and funny). It understands the
      impulse to take on a project, even when you're cooking just for
      yourself—and why that's a perfectly worthwhile thing.{" "}
    </span>
  )
}

const result69Description = () => {
  return (
    <span>
      This luxe breakfast tea comes in beautiful packaging that almost doesn't
      need to be wrapped. Pair it with the{" "}
      <a
        href="https://fave.co/3cD3Afq"
        target="_blank"
        rel="noreferrer"
        style={{ textDecoration: "none", color: "#E4503B" }}>
        Earl Grey
      </a>{" "}
      and{" "}
      <a
        href="https://fave.co/3xeodrq"
        target="_blank"
        rel="noreferrer"
        style={{ textDecoration: "none", color: "#E4503B" }}>
        Tea Rouge
      </a>{" "}
      tin and you'll have something for every kind of tea lover: a rich black
      tea, bright, grassy green tea, and a nutty-sweet almond red tea.{" "}
    </span>
  )
}

const result66Description = () => {
  return (
    <span>
      For the cook who loves a project, maybe 2022 is the year of mastering
      homemade ice cream. Give the gift of our{" "}
      <a
        href="https://www.epicurious.com/shopping/best-ice-cream-maker-article"
        target="_blank"
        rel="noreferrer"
        style={{ textDecoration: "none", color: "#E4503B" }}>
        product test
      </a>{" "}
      winner to set the hobby on its way.
    </span>
  )
}

const result48Description = () => {
  return (
    <span>
      We love the simple, easy-to-master recipes in this book from GBBS alum Ed
      Kimber: Try the{" "}
      <a
        href="https://www.epicurious.com/recipes/food/views/peanut-butter-brookies-edd-kimber"
        target="_blank"
        rel="noreferrer"
        style={{ textDecoration: "none", color: "#E4503B" }}>
        peanut butter brookies
      </a>{" "}
      first.
    </span>
  )
}

const result41Description = () => {
  return (
    <span>
      Haphazard storage can ruin even the freshest tea or coffee. Help the
      coffee or tea enthusiast in your life keep their beans airtight with these
      sleek vacuum-sealed canisters that we{" "}
      <a
        href="https://www.epicurious.com/shopping/fellow-vacuum-coffee-canisters-article"
        target="_blank"
        rel="noreferrer"
        style={{ textDecoration: "none", color: "#E4503B" }}>
        reviewed earlier this year
      </a>{" "}
      and loved.
    </span>
  )
}

const result2Description = () => {
  return (
    <span>
      Homemade tortillas are a game-changer. This model won our tortilla press
      <a
        href="https://www.epicurious.com/shopping/the-best-tortilla-press-for-freshly-made-tortillas-any-time-article"
        target="_blank"
        rel="noreferrer"
        style={{ textDecoration: "none", color: "#E4503B" }}>
        product review
      </a>
      , and its pretty design makes it extra giftable.
    </span>
  )
}

export const results = [
  {
    resultId: 116,
    Result: "Angled Nick & Nora Glasses",
    Link: "https://fave.co/3l1QQDH",
    Price: "$38",
    Retailer: "Walmart",
    Category: "Cocktail",
    Description:
      "Nick & Nora glasses are great for any cocktails that are served without ice in the glass; these from Viski are a particularly stylish choice.",
    ImageURL:
      "https://assets.epicurious.com/photos/619d15a5dbff3b368b57e2cf/1:1/pass/21_Epi_GG_Quiz_art_NICKNORA_VOG.jpg",
  },
  {
    resultId: 115,
    Result: "Select Apertivo",
    Link: "https://fave.co/3cCvF6u",
    Price: "$34",
    Retailer: "Reserve Bar",
    Category: "Cocktail",
    Description:
      "Sip a spritz the way they do in Venice with this classic bittersweet bottling. ",
    ImageURL:
      "https://assets.epicurious.com/photos/619d15a5f9025e076e836036/1:1/pass/21_Epi_GG_Quiz_art_SELECTAPERITIF_VOG.jpg",
  },
  {
    resultId: 114,
    Result: "Palais des Thés\nMatcha Tea Set",
    Link: "https://fave.co/3nIvwVe",
    Price: "$59",
    Retailer: "Food52",
    Category: "Tea",
    Description:
      "For longtime matcha fans or tea lovers new to the practice, this tea set from Palais des Thés will set anyone up for success. The box contains a skinny bamboo tea scoop (the right size for a single serving of matcha), bamboo chasen (the delicate whisk used to emulsify the tea and water), and a ceramic chawan (tea bowl, for mixing and drinking).",
    ImageURL:
      "https://assets.epicurious.com/photos/619d133ccfdb0bee0549c0a1/1:1/pass/palaisdethes_matchkit_VOG_final.png",
  },
  {
    resultId: 113,
    Result: "Finum Stainless Steel Mesh Brewing Basket",
    Link: "https://amzn.to/3DKLaVD",
    Price: "$11",
    Retailer: "Amazon",
    Category: "Tea",
    Description:
      "This micro-mesh stainless-steel brewing basket with a plastic frame took home the gold in our test of the best tea-steeping baskets. It fit well into multiple sizes of mugs and kept all kinds of leaves and sediment, no matter how small, from leaking into our cup. It comes with a lid that fully covers the strainer and acts as a lid for the tea-making vessel so your tea stays hot and aromatic while it steeps.",
    ImageURL:
      "https://assets.epicurious.com/photos/619d13451bc844adc7a619c1/1:1/pass/Finum_111220_GIFTGUIDE_SILO_VOG_final.png",
  },
  {
    resultId: 112,
    Result: "Sweet Home Enamel Milk Pot",
    Link: "https://amzn.to/3cDwImE",
    Price: "$21",
    Retailer: "Amazon",
    Category: "Coffee",
    Description:
      "Use this little pot to warm milk or cream for coffee, to reheat your whole cup, or to add in some cocoa for a mocha. ",
    ImageURL:
      "https://assets.epicurious.com/photos/61982115cb910d4f24b3b007/1:1/pass/mdzfsweet_VOG_final.png",
  },
  {
    resultId: 111,
    Result: "Barolo Chinato ",
    Link: "https://fave.co/3HJX5FD",
    Price: "$100",
    Retailer: "Wine.com",
    Category: "Wine",
    Description:
      "Barolo Chinato is a deeply flavored beverage that combines one of the great wines of Italy with the sorts of spices you'd find in vermouth. It makes a luxurious after-dinner drink, and the ultimate winter spritz.",
    ImageURL:
      "https://assets.epicurious.com/photos/61982118edadb2ce5aa72968/1:1/pass/Result%20No.%20111.png",
  },
  {
    resultId: 110,
    Result: "Smithey Carbon Steel Round Roaster",
    Link: "https://fave.co/3cC10Gf",
    Price: "$275",
    Retailer: "Smithey",
    Category: "Cooking",
    Description:
      "This hand-forged carbon-steel roaster is preseasoned, so the lucky recipient of this cooking gift can get started making cozy winter roasts right away. Personalize it with an engraving for an extra $40.",
    ImageURL:
      "https://assets.epicurious.com/photos/6198211975d5cc622a8962ef/1:1/pass/Quiz%20Result%20No.%20110.png",
  },
  {
    resultId: 109,
    Result: "Tortise Shell Resin Bowl, Medium",
    Link: "https://fave.co/3qYPHAp",
    Price: "$78",
    Retailer: "Food52",
    Category: "Entertaining",
    Description:
      "We’re obsessed with this entire tortoiseshell resin line—especially the way light hits it. The serving bowls are perfect for salads, grain-based side dishes, or just for displaying fruit.",
    ImageURL:
      "https://assets.epicurious.com/photos/619821228c2b8551b4a4c784/1:1/pass/tortoiseshellbowls_tout_VOG_final.png",
  },
  {
    resultId: 108,
    Result: "Kinto Sepia Amber Glasses",
    Link: "https://fave.co/3nBHobD",
    Price: "$76",
    Retailer: "Food52",
    Category: "Tea",
    Description:
      "This amber glass mug is delicate and stylish: perfect for your morning cup of black or green tea.",
    ImageURL:
      "https://assets.epicurious.com/photos/619821191c90da1238d2a02c/1:1/pass/Quiz%20Result%20No.%20108.png",
  },
  {
    resultId: 107,
    Result: "Jono Pandolfi Ombre Platter",
    Link: "https://fave.co/3FEHoxG",
    Price: "$65",
    Retailer: "Jono Pandolfi",
    Category: "Entertaining",
    Description:
      "Ceramic serving platters make good gifts for folks who love to host—and this platter looks fantastic whether presenting a cheese assortment or a whole chicken. It’s also dishwasher-safe, and you can choose from subtle neutrals or bright ombrés.",
    ImageURL:
      "https://assets.epicurious.com/photos/619821191eebb0da631b179b/1:1/pass/Quiz%20Result%20No.%20107.png",
  },
  {
    resultId: 106,
    Result: "Bormiolo Rocco Nick and Nora Glasses",
    Link: "https://amzn.to/3oX005A",
    Price: "$28/4",
    Retailer: "Amazon",
    Category: "Entertaining",
    Description:
      "If your favorite home bartender is still handing you gimlets in a standard martini glass, give them an upgrade. Slightly larger than a Nick and Nora, these Italian fizz glasses are versatile vessels for any drink that’s shaken or stirred and served up.",
    ImageURL:
      "https://assets.epicurious.com/photos/6198211a75d5cc622a8962f1/1:1/pass/Quiz%20Result%20No.%20106.png",
  },
  {
    resultId: 105,
    Result: "Kinto Iced Tea Glass",
    Link: "https://fave.co/3HFWzbQ",
    Price: "$60/4 glasses",
    Retailer: "Food52",
    Category: "Coffee",
    Description:
      "These double-walled glass cups will keep your iced coffee chilly—and look great doing it. ",
    ImageURL:
      "https://assets.epicurious.com/photos/6198211aaece33a8e0f8445e/1:1/pass/Quiz%20Result%20No.%20105.png",
  },
  {
    resultId: 104,
    Result: "Coava Whole Bean Coffee",
    Link: "https://fave.co/3FHk8zl",
    Price: "$18",
    Retailer: "Food52",
    Category: "Coffee",
    Description:
      "These single-origin beans from Coava are sourced by the Portland-based roasting company through truly sustainable partnerships with growers.",
    ImageURL:
      "https://assets.epicurious.com/photos/6198211becf2f9634042667d/1:1/pass/Quiz%20Result%20No.%20104.png",
  },
  {
    resultId: 103,
    Result: "Puik Designs Stacking Ceramic Monday Espresso Mug",
    Link: "https://fave.co/3CItEjw",
    Price: "$38",
    Retailer: "West Elm",
    Category: "Coffee",
    Description:
      "These modern-looking espresso cups are visually dynamic enough to make an exciting gift, but neutral enough to fit anyone's kitchen aesthetic. ",
    ImageURL:
      "https://assets.epicurious.com/photos/6198212454a31a5cf1e3da95/1:1/pass/puikdesignsmondayespresso_VOG_final.png",
  },
  {
    resultId: 102,
    Result: "The Oxford Cocktail Companion ",
    Link: "https://amzn.to/3xcb9mq",
    Price: "$58",
    Retailer: "Amazon",
    Category: "Cocktail",
    Description:
      "This new 834 page book is sure to become an invaluable, nearly definitive reference for people in the drinks world—and it makes the perfect gift for the cocktail nerd in your life.",
    ImageURL:
      "https://assets.epicurious.com/photos/6198211b1c90da1238d2a02e/1:1/pass/Quiz%20Result%20No.%20102.png",
  },
  {
    resultId: 101,
    Result: "Riedel Crystal Rocks Glass",
    Link: "https://fave.co/3xaNZwO",
    Price: "$66 for 4",
    Retailer: "Saks Fifth Ave",
    Category: "Cocktail",
    Description:
      "Classic cocktail lovers will love this classic glass. Pair the set with a good bottle of whiskey.",
    ImageURL:
      "https://assets.epicurious.com/photos/6198211da4258b73bd2f2e35/1:1/pass/Quiz%20Result%20No.%20101.png",
  },
  {
    resultId: 100,
    Result: "The Way of the Cocktail",
    Link: "https://amzn.to/3r41Wf0",
    Price: "$28",
    Retailer: "Amazon",
    Category: "Cocktail",
    Description:
      "This beautiful book from Julia Momosé of Kumiko in Chicago has plenty to keep a craft cocktail connoisseur busy this winter. In addition to the drink recipes, which are categorized by Japan’s 24 micro-seasons, it’s a love letter to the traditions, techniques, philosophies, and spirits that define Japanese cocktail culture.",
    ImageURL:
      "https://assets.epicurious.com/photos/61982118021ada8771c25b89/1:1/pass/Way%20of%20the%20Cocktail.png",
  },
  {
    resultId: 99,
    Result: "Thermapen Mk4",
    Link: "https://fave.co/3oUcTgD",
    Price: "$98",
    Retailer: "ThermoWorks",
    Category: "Cooking",
    Description:
      "The key to excellent deep frying, braising, roasting, baking...and, well, any kind of cooking? Precise temperature monitoring. For that, give the gift of our all-time favorite digital thermometer.",
    ImageURL:
      "https://assets.epicurious.com/photos/6198211c51794f92483fe5ba/1:1/pass/Quiz%20Result%20No.%2099.png",
  },
  {
    resultId: 98,
    Result: "Instant Pot Duo",
    Link: "https://amzn.to/3CHXm8y",
    Price: "$80",
    Retailer: "Amazon",
    Category: "Cooking",
    Description:
      "If the weeknight cook on your list doesn't have an Instant Pot yet, you're about to change their life. Beans, soups, stews, and braises are possible even after a long day of work with this wonderous multi-cooker.",
    ImageURL:
      "https://assets.epicurious.com/photos/6198211f51794f92483fe5be/1:1/pass/Quiz%20Result%20No%2098.png",
  },
  {
    resultId: 97,
    Result: "Breville Smart Oven Compact Convection",
    Link: "https://amzn.to/30PlSah",
    Price: "$150",
    Retailer: "Amazon",
    Category: "Cooking",
    Description:
      "When you're cooking for one or two, a toaster oven is a total game-changer: It heats up faster than your full-size oven, and it's more efficient, plus, it's just the right size for a couple of chicken thighs or pieces of salmon. This Breville model came out on top in our product review thanks to great convection cooking ability and thoughtful features. If you really want to go all out, pair the gift with a set of toaster oven bakeware.",
    ImageURL:
      "https://assets.epicurious.com/photos/6198211cd9d5577df6d665ba/1:1/pass/Quiz%20Result%20No.%2097.png",
  },
  {
    resultId: 96,
    Result: "Instant Pot Sous Vide",
    Link: "https://amzn.to/3oZE21s",
    Price: "$90",
    Retailer: "Amazon",
    Category: "Cooking",
    Description:
      "An immersion circulator may seem like a tool for the science-focused pros, but actually, it's kind of like a new-fangled slow cooker. Cook perfect breakfast eggs with it, or use it to get a weeknight dinner on the table.",
    ImageURL:
      "https://assets.epicurious.com/photos/6198211fecf2f96340426681/1:1/pass/Quiz%20Result%20No%2096.png",
  },
  {
    resultId: 95,
    Result: "Prep Bowls",
    Link: "https://amzn.to/3oQyDdb",
    Price: "$25",
    Retailer: "Amazon",
    Category: "Cooking",
    Description:
      "Whether you're cooking simple weeknight meals or taking on many-step project recipes, it's helpful to prep and neatly set out all of your ingredients before turning on any burners. These prep bowls make that easy—and they are a favorite of our reviews editor, Noah.",
    ImageURL:
      "https://assets.epicurious.com/photos/6198211decf2f9634042667f/1:1/pass/Quiz%20Result%20No.%2095.png",
  },
  {
    resultId: 94,
    Result: "Dash Waffle Maker",
    Link: "https://fave.co/30Pm617",
    Price: "$10",
    Retailer: "Bed Bath & Beyond",
    Category: "Cooking",
    Description:
      "This mini waffle maker isn't just a viral TikTok gimmick. We tested it, and found it actually made great waffles—and for ten dollars, it's an incredible-for-the-price stocking stuffer for the cook who loves breakfast.",
    ImageURL:
      "https://assets.epicurious.com/photos/61982120a4258b73bd2f2e37/1:1/pass/Quiz%20Result%20No%2094.png",
  },
  {
    resultId: 93,
    Result: "Quarter Sheet Pan",
    Link: "https://amzn.to/3kZRocV",
    Price: "$22",
    Retailer: "Amazon",
    Category: "Cooking",
    Description:
      "There's something so satisfying about roasting just the right amount of vegetables for one, and this mini version of our product-test winning sheet pan is the perfect size for that. ",
    ImageURL:
      "https://assets.epicurious.com/photos/6198211e51794f92483fe5bc/1:1/pass/Quiz%20Result%20No.%2093.png",
  },
  {
    resultId: 92,
    Result: "Jasper Hill Farm Cheese Tasting Box",
    Link: "https://fave.co/30L8XX2",
    Price: "$150",
    Retailer: "Food52",
    Category: "Wine",
    Description:
      "Many wine lovers prefer a savory after-dinner course over a sweet one, especially if there's still wine to be sipped. This sampling of cheeses from beloved purveyor Jasper Hill Farms will go down easy as they work on finishing all the bottles on the table this holiday season. ",
    ImageURL:
      "https://assets.epicurious.com/photos/61982124aece33a8e0f84462/1:1/pass/cheesegift_VOG_final.png",
  },
  {
    resultId: 91,
    Result: "Blind Tasting Class",
    Link: "https://fave.co/3DJAFC3",
    Price: "$180",
    Retailer: "Master Class",
    Category: "Wine",
    Description:
      "This Master Class from wine critic James Suckling will help your favorite wine lover hone their tasting skills—and learn a lot while they're at it.",
    ImageURL:
      "https://assets.epicurious.com/photos/61982121a3b3cd0efa674961/1:1/pass/Masterclass-2.png",
  },
  {
    resultId: 90,
    Result: "Wine Decanter",
    Link: "https://amzn.to/3HHn7JH",
    Price: "$50",
    Retailer: "Amazon",
    Category: "Wine",
    Description:
      "If your favorite red wine lover doesn't have a nice decanter—we'll pause here while you snoop around—their evening routine is about to get much more delicious. ",
    ImageURL:
      "https://assets.epicurious.com/photos/6198211e89f2fc538ca5b6bf/1:1/pass/Quiz%20Result%20No.%2090.png",
  },
  {
    resultId: 89,
    Result: "Wine Fridge",
    Link: "https://fave.co/3cCwEni",
    Price: "$180",
    Retailer: "Wine Enthusiast",
    Category: "Wine",
    Description:
      "A mini wine fridge is perfect for storing the everyday wines you’re going to be drinking soon. Wine Enthusiast’s 6-bottle fridge has a digital touch screen and LED temperature display for easy control.",
    ImageURL:
      "https://assets.epicurious.com/photos/6198211f54a31a5cf1e3da93/1:1/pass/Quiz%20Result%20No.%2089.png",
  },
  {
    resultId: 88,
    Result: "Glasvin Burgundy Glass, Set of 6",
    Link: "https://fave.co/3kZjQvF",
    Price: "$240",
    Retailer: "Glasvin",
    Category: "Wine",
    Description:
      "These delicate handblown glasses are paper-thin and offer a superior sipping experience. The large bowl shape gives plenty of room for well-aged wines (or even cheeky spritzes!) to breathe.",
    ImageURL:
      "https://assets.epicurious.com/photos/6198212251794f92483fe5c0/1:1/pass/WhiteFinal_VOG_final.png",
  },
  {
    resultId: 87,
    Result: "Blind Tasting Class",
    Link: "https://fave.co/3cAdQVy",
    Price: "$165",
    Retailer: "Master Class",
    Category: "Wine",
    Description:
      "This Master Class from wine critic James Suckling will help your favorite wine lover hone their tasting skills—and learn a lot while they're at it.",
    ImageURL:
      "https://assets.epicurious.com/photos/61982122aece33a8e0f84460/1:1/pass/Masterclass-1.png",
  },
  {
    resultId: 86,
    Result: "Serrano Bone-In Ham from Spain",
    Link: "https://amzn.to/3r8rXK2",
    Price: "$200",
    Retailer: "Amazon",
    Category: "Wine",
    Description:
      "There is no better match than sherry and Spanish ham—and no better reason to gather friends together than a whole jamon and a few bottles of the good stuff.",
    ImageURL:
      "https://assets.epicurious.com/photos/619821211c90da1238d2a030/1:1/pass/Quiz%20Result%20No%2086.png",
  },
  {
    resultId: 85,
    Result: "Glasvin Universal Glass, Set of 6",
    Link: "https://fave.co/3DHX6aV",
    Price: "$160",
    Retailer: "Parcelle",
    Category: "Wine",
    Description:
      "These delicate, handblown (but dishwasher-safe!) glasses are paper-thin and offer a superior sipping experience. The versatile universal glasses work well for whatever wines are on the docket.",
    ImageURL:
      "https://assets.epicurious.com/photos/619d12c1dbff3b368b57e2cd/1:1/pass/21_Epi_GG_Quiz_art_Glavsin_6_VOG.jpg",
  },
  {
    resultId: 84,
    Result: "Wine Coaster",
    Link: "https://fave.co/3d7e8Dw",
    Price: "$34",
    Retailer: "Pottery Barn",
    Category: "Wine",
    Description:
      "Wine coasters are a bit frivolous, sure, but that's what makes them such a great gift. Prevent table drips and red wine wood stains with these beauties.",
    ImageURL:
      "https://assets.epicurious.com/photos/61982098021ada8771c25b7d/1:1/pass/21_Epi_GG-Quiz-Art_silverplatters_VOG.png",
  },
  {
    resultId: 83,
    Result: "Aplat 2-Bottle Tote",
    Link: "https://fave.co/3nL9KQM",
    Price: "$50",
    Retailer: "Williams Sonoma",
    Category: "Wine",
    Description:
      "This stylish wine tote slings right over your shoulder comfortably. The strap cleverly functions to keep two bottles from clanking together while you're commuting them to a wine-soaked dinner party.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820bd8c2b8551b4a4c782/1:1/pass/21_Epi_GG-Quiz-Art_Aplat-Two-Bottle-Tote-Stone_VOG.png",
  },
  {
    resultId: 82,
    Result: "Wine Style",
    Link: "https://amzn.to/30RkzYo",
    Price: "$19",
    Retailer: "Amazon",
    Category: "Wine",
    Description:
      "Maybe the person you're shopping for knows that they love fun and fresh-tasting natural wines—but do they really know how to pair those wines with food? This new-wave pairing book will guide them to plenty of options and recipes that go well with every style of bottling in wine shops today.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820961eebb0da631b178b/1:1/pass/21_Epi_GG-Quiz-Art_WineStyle_VOG.png",
  },
  {
    resultId: 81,
    Result: "Domaine Tempier Bandol Rosé",
    Link: "https://fave.co/3CHMpUj",
    Price: "$50",
    Retailer: "Parcelle",
    Category: "Wine",
    Description:
      "This is serious rosé, and it just gets better with a few years in the cellar. (It's also not available early in rosé season, so it's crucial to keep a few bottles on hand so you're properly prepared for the first warm days of spring.)",
    ImageURL:
      "https://assets.epicurious.com/photos/61982097021ada8771c25b7b/1:1/pass/21_Epi_GG-Quiz-Art_Tempier-Rose-Bandol_VOG.png",
  },
  {
    resultId: 80,
    Result: "Best of France Cheese Sampler",
    Link: "https://fave.co/3xbZB2E",
    Price: "$85",
    Retailer: "Murray's",
    Category: "Wine",
    Description:
      "Many wine lovers prefer a savory after-dinner course over a sweet one, especially if there's still wine to be sipped. This sampling of French cheeses will go down easy as they work on finishing all the bottles on the table this holiday season. ",
    ImageURL:
      "https://assets.epicurious.com/photos/619820ba021ada8771c25b87/1:1/pass/21_Epi_GG-Quiz-Art_CheeseSubscription_VOG.png",
  },
  {
    resultId: 79,
    Result: "Oyster Shipment",
    Link: "https://fave.co/3oLhUrI",
    Price: "$29 + shipping",
    Retailer: "Goldbelly",
    Category: "Wine",
    Description:
      "What always goes with minerally, bright white wines? Briny oysters. Have them shipped to your favorite wine lover's door this holiday season. ",
    ImageURL:
      "https://assets.epicurious.com/photos/6198209c54a31a5cf1e3da8b/1:1/pass/21_Epi_GG-Quiz-Art_PikePlace-Kumamoto-Oysters-Product-2_VOG.png",
  },
  {
    resultId: 78,
    Result: "Mayeteria Sanluquena Corta Y Raspa Mahina",
    Link: "https://fave.co/30Sgfsu",
    Price: "$24",
    Retailer: "Parcelle",
    Category: "Wine",
    Description:
      "Palomino fino grapes are generally used to make sherry—but this fascinating white wine from Sanlúcar de Barrameda, produced by a family who has been growing grapes there for four generations, isn't fortified. It's tangy and savory, with electric acidity, and it's wonderful with seafood. ",
    ImageURL:
      "https://assets.epicurious.com/photos/6198209bcb910d4f24b3b001/1:1/pass/21_Epi_GG-Quiz-Art_mayeteria-sanluquena-corta-raspa-anina-white_VOG.png",
  },
  {
    resultId: 77,
    Result: "Bormiolo Rocco Wine Carafe",
    Link: "https://amzn.to/2Zc15xk",
    Price: "$17",
    Retailer: "Amazon",
    Category: "Wine",
    Description:
      "Digital Director Maggie Hoffman prefers this simple carafe over a full-scale wine decanter: It's more versatile, easier to clean and fit in a cabinet, and it has a chic, no-fuss look about it—all while getting the decanting job done just fine. ",
    ImageURL:
      "https://assets.epicurious.com/photos/619820a01eebb0da631b178d/1:1/pass/21_Epi_GG-Quiz-Art_GlassVase_VOG.png",
  },
  {
    resultId: 76,
    Result: "Vacu Vin",
    Link: "https://amzn.to/3nGRxE8",
    Price: "$17",
    Retailer: "Amazon",
    Category: "Wine",
    Description:
      "Don't have room for an ice bucket? Want to chill wine without having to buy bags of ice? These cooling packs can be kept in the freezer, then nestled around your favorite bottle to keep it chilled at the table. ",
    ImageURL:
      "https://assets.epicurious.com/photos/619820be51794f92483fe5b8/1:1/pass/21_Epi_GG-Quiz-Art_ActiveCooler_Platinum_VOG.png",
  },
  {
    resultId: 75,
    Result: "Monopol Westmark Germany Steel 2-Prong Cork Puller",
    Link: "https://amzn.to/32jjwRT",
    Price: "$25",
    Retailer: "Amazon",
    Category: "Wine",
    Description:
      "Most serious wine drinkers have plenty of regular corkscrews and bottle openers, but sometimes a corkscrew just won’t cut it. Or rather, it will cut through a little too enthusiastically, causing an older, more delicate cork to crumble into the bottle. Enter the ah-so wine opener, which slides around the wine cork rather than through it, allowing you to jiggle the cork out tweezer-style and skip the flurry of cork bits in your precious beverage. This is the perfect gift to pair with a well-aged bottle.",
    ImageURL:
      "https://assets.epicurious.com/photos/61982096cb910d4f24b3affb/1:1/pass/21_Epi_GG-Quiz-Art_Westmark_VOG.png",
  },
  {
    resultId: 74,
    Result: "Three-Tiered Cake Stand",
    Link: "https://fave.co/3r1nLfo",
    Price: "$150",
    Retailer: "Food52",
    Category: "Baking",
    Description:
      "Tea-time treats and confections will look great displayed on this multi-tiered stand; each vintage piece is unique, and with one you can embody the classic English aesthetic of your dreams. ",
    ImageURL:
      "https://assets.epicurious.com/photos/619820bbcb910d4f24b3b005/1:1/pass/21_Epi_GG-Quiz-Art_brooklynteacupvintageenglishtransferware_3tier_VOG.png",
  },
  {
    resultId: 73,
    Result: "Le Creuset Dutch Oven",
    Link: "https://amzn.to/3xcaBNu",
    Price: "$355",
    Retailer: "Amazon",
    Category: "Baking",
    Description:
      "A Dutch oven will help the ambitious cook in your life accomplish many intricate kitchen projects: Use it for deep frying, making a crusty loaf of bread, or tackling an all-day coq au vin.",
    ImageURL:
      "https://assets.epicurious.com/photos/6198209f7b3f5e4c0a803844/1:1/pass/21_Epi_GG-Quiz-Art_LeCreusetDutchOven_VOG.png",
  },
  {
    resultId: 72,
    Result: "Hand Blown Glass Cake Stand",
    Link: "https://fave.co/3xgCNif",
    Price: "$225",
    Retailer: "Food52",
    Category: "Baking",
    Description:
      "Every single thing that Estelle Colored Glass produces is gift-worthy, but if you’re after just one piece, make it this stunner of a cake stand. ",
    ImageURL:
      "https://assets.epicurious.com/photos/619820a154a31a5cf1e3da8d/1:1/pass/21_Epi_GG-Quiz-Art_Food52CakeStands_VOG.png",
  },
  {
    resultId: 71,
    Result: "Wilton Tall Cake Pan",
    Link: "https://amzn.to/3DLywGe",
    Price: "$10",
    Retailer: "Amazon",
    Category: "Baking",
    Description:
      "According to cook and writer Odette Williams, one kitchen tool can provide the impressive height of professional-looking cakes, without any extra effort. The key “to feeling like a cake pro,” she says, “is a three-inch-tall pan. Everyone should buy one.” This holiday season, you can give one. And then hopefully be invited over for cake.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820bc7b3f5e4c0a80384c/1:1/pass/21_Epi_GG-Quiz-Art_baking_tin_VOG.png",
  },
  {
    resultId: 70,
    Result: "Silpat Baking Molds",
    Link: "https://fave.co/32qJKlF",
    Price: "$63",
    Retailer: "Williams Sonoma",
    Category: "Baking",
    Description:
      "With these molds, even bakers who stick to the simple stuff can turn out bakery-worthy fluted madeleines and intricate mini Bundts. ",
    ImageURL:
      "https://assets.epicurious.com/photos/61982099021ada8771c25b7f/1:1/pass/21_Epi_GG-Quiz-Art_silpat_tin.png",
  },
  {
    resultId: 69,
    Result: "Mariage Freres International Breakfast Tea",
    Link: "https://fave.co/3HNumQj",
    Price: "$32",
    Retailer: "Neiman Marcus",
    Category: "Tea",
    Description: result69Description(),
    ImageURL:
      "https://assets.epicurious.com/photos/6198209ea4258b73bd2f2e31/1:1/pass/21_Epi_GG-Quiz-Art_marriage_VOG.png",
  },
  {
    resultId: 68,
    Result: "Denshiro Tea Canister",
    Link: "https://fave.co/2ZdF69f",
    Price: "$140",
    Retailer: "Jinen",
    Category: "Tea",
    Description:
      "These beloved Japanese tea canisters, made from wild cherry tree bark, grow more beautiful every day: As you handle the wood, it develops a sheen. This is a luxurious gift that will last a lifetime for the serious tea lover in your life. ",
    ImageURL:
      "https://assets.epicurious.com/photos/619820b5ecf2f96340426677/1:1/pass/21_Epi_GG-Quiz-Art_denshiro_Kizutsu_VOG.png",
  },
  {
    resultId: 67,
    Result: "Degrenne Salam Insulated Teapot",
    Link: "https://fave.co/30Ndjgv",
    Price: "$150",
    Retailer: "Food52",
    Category: "Tea",
    Description:
      "This teapot, fitted with a stainless steel insert for loose-leaf teas, is inspired by Bedouin models. The porcelain pot that holds the tea is surrounded by felt-lined stainless steel, so that your brew will stay hot for over an hour. And it sure looks gorgeous on the table.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820b6dbc20a67736dd037/1:1/pass/21_Epi_GG-Quiz-Art_degrenne_salamteapot6cup_VOG.png",
  },
  {
    resultId: 66,
    Result: "Cuisinart Ice Cream Maker",
    Link: "https://amzn.to/3qXEzUj",
    Price: "$70",
    Retailer: "Amazon",
    Category: "Entertaining",
    Description: result66Description(),
    ImageURL:
      "https://assets.epicurious.com/photos/619820b61c90da1238d2a02a/1:1/pass/21_Epi_GG-Quiz-Art_Cuisinart_VOG.png",
  },
  {
    resultId: 65,
    Result: "Ravioli stamp",
    Link: "https://amzn.to/3CH5gyZ",
    Price: "$10",
    Retailer: "Amazon",
    Category: "Entertaining",
    Description:
      "Homemade ravioli is a project, no doubt. But the reward is well worth the effort. Stamp out lovely fluted-edged round and square pasta with this tool, which happens to make a great stocking stuffer.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820995b158ca6a4ec5b6c/1:1/pass/21_Epi_GG-Quiz-Art_Ravioli_Stamp_VOG.png",
  },
  {
    resultId: 64,
    Result: "Espro French Press",
    Link: "https://amzn.to/32vPg6w",
    Price: "$150",
    Retailer: "Amazon",
    Category: "Coffee",
    Description:
      "A gorgeous, useful gift for folks who love a rich cup of coffee but might be ready for an upgrade from their regular French press. This stainless steel press is sturdy and much less likely to break than the standard glass model. It's double-walled for insulation, so you don't have to worry about your coffee going cold before the second cup. It has two microfilters and a double lip seal, which prevent grint from sneaking through into your coffee.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820a346256f3a0a1d3d59/1:1/pass/21_Epi_GG-Quiz-Art_espro-pdp-p7-polished_VOG.png",
  },
  {
    resultId: 63,
    Result: "Bruer Grey Cold Drip Coffee System",
    Link: "https://amzn.to/3kUQ772",
    Price: "$80",
    Retailer: "Amazon",
    Category: "Coffee",
    Description:
      "This hourglass dripper is modeled after a Kyoto-style brewer. It's a great gift for coffee aficionados who think learning a complicated new machine is thrilling, and who want the absolute best cup of cold brew.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820b746256f3a0a1d3d5b/1:1/pass/21_Epi_GG-Quiz-Art_coldbrewcoffeemaker_VOG.png",
  },
  {
    resultId: 62,
    Result: "Espresso Cups",
    Link: "https://fave.co/3nFeGGZ",
    Price: "$48/4",
    Retailer: "Etsy",
    Category: "Coffee",
    Description:
      "For the espresso lover who still needs some basics, opt for these smooth, modern espresso cups in soothing neutral and pastel tones.",
    ImageURL:
      "https://copilot.condenast.io/epi/photos/619820a1fa4849e9c207616d",
  },
  {
    resultId: 61,
    Result: "Ceramic Cream and Sugar Bowl",
    Link: "https://fave.co/3DHhCbH",
    Price: "$55",
    Retailer: "Etsy",
    Category: "Coffee",
    Description:
      "A sleek, streamlined cream and sugar set will make regular morning cups with family feel like fancy brunches—and it looks great on the brunch table when you're entertaining, too.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820a251794f92483fe5b0/1:1/pass/21_Epi_GG-Quiz-Art_etsy_mugs_VOG.png",
  },
  {
    resultId: 60,
    Result: "Chemex Cream and Sugar Set",
    Link: "https://fave.co/3oKzagK",
    Price: "$40",
    Retailer: "Crate & Barrel ",
    Category: "Coffee",
    Description:
      "This milk and sugar set is a clever miniature version of the beloved pourover cofffee maker, the Chemex. If the person you're giving it to makes coffee in a Chemex, it'll match perfectly—but even if they use another pourover system, this is a chic and well-designed addition to their morning routine.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820b851794f92483fe5b6/1:1/pass/21_Epi_GG-Quiz-Art_ChemexCreamandSugarSetAV3F15_VOG.png",
  },
  {
    resultId: 59,
    Result: "Kinto Faro Coffee Dripper and Thermo Mug",
    Link: "https://amzn.to/3FJdhFz",
    Price: "$51",
    Retailer: "Amazon",
    Category: "Coffee",
    Description:
      "This Faro mug coffee service set from Japanese brand Kinto is beautifully understated. The porcelain and stainless-steel collection comes with a stackable pot, a mug, a brewer, and a strainer. Every piece has a double-wall construction and is dishwasher-safe.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820b91eebb0da631b1797/1:1/pass/21_Epi_GG-Quiz-Art_CoffeeMugs_VOG.png",
  },
  {
    resultId: 58,
    Result: "Takeya Cold Brew Coffee Maker",
    Link: "https://amzn.to/3DG7boE",
    Price: "$25",
    Retailer: "Amazon",
    Category: "Coffee",
    Description:
      "In our product review, the Takeya Deluxe took the prize as the best cold-brew maker for a stronger cup of coffee. The Takeya has a long, large infusing basket to allow for more contact between the grounds and water, making it ideal for iced coffee lovers who want to make cold brew concentrate.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820b854a31a5cf1e3da8f/1:1/pass/21_Epi_GG-Quiz-Art_ColdB2_Rightside_VOG.png",
  },
  {
    resultId: 57,
    Result: "Cocktail Shaker",
    Link: "https://amzn.to/3l0nLbu",
    Price: "$25",
    Retailer: "Amazon",
    Category: "Coffee",
    Description:
      "Maybe the person you're shopping for started mixing drinks at home during the pandemic, but doesn't have all the basic tools yet. This sturdy, shiny cocktail shaker was a favorite in our product test. ",
    ImageURL:
      "https://assets.epicurious.com/photos/619820bc8c2b8551b4a4c780/1:1/pass/21_Epi_GG-Quiz-Art_bostonshakerset_VOG.png",
  },
  {
    resultId: 56,
    Result: "Coffee Sock",
    Link: "https://amzn.to/3CEfS1t",
    Price: "$14",
    Retailer: "Amazon",
    Category: "Coffee",
    Description:
      "We tested this reusable filter, and found it make a cup of coffee on par with its paper counterparts. It comes in a variety of designs, which you can select based on the filter your coffee maker takes. The perfect gift for the sustainably-minded pourover lover.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820a0fa4849e9c207616b/1:1/pass/21_Epi_GG-Quiz-Art_halfmoon_new_VOG.png",
  },
  {
    resultId: 55,
    Result: "Hydro Flask Day Escape Soft Cooler Pack",
    Link: "https://fave.co/2ZcDbSv",
    Price: "$200",
    Retailer: "REI",
    Category: "Camping",
    Description:
      "Carry the ultimate picnic lunch with you on a long hike, and keep it chilled the whole time.",
    ImageURL:
      "https://assets.epicurious.com/photos/6198209f1c90da1238d2a028/1:1/pass/21_Epi_GG-Quiz-Art_HydroFlask_VOG.png",
  },
  {
    resultId: 54,
    Result: "Yeti Portable Cooler",
    Link: "https://amzn.to/3kYV0fc",
    Price: "$300",
    Retailer: "Amazon",
    Category: "Camping",
    Description:
      "This splurgy cooler is the ultimate camping, tailgating, or picnicking status symbol. It keeps beverages icy cold, it's comfortable to carry, and it looks great wherever you take it.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820a4a3b3cd0efa67495f/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_YetiCooler_VOG.png",
  },
  {
    resultId: 53,
    Result: "Pie Iron",
    Link: "https://amzn.to/3reEn3t",
    Price: "$23",
    Retailer: "Amazon",
    Category: "Camping",
    Description:
      "With a pie iron, you can go beyond grilled basics: Make melty, crispy sandwiches, and, yes, perfect little hand pies, over the campfire.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820977b3f5e4c0a803842/1:1/pass/21_Epi_GG-Quiz-Art_toas-tite-grill_VOG.png",
  },
  {
    resultId: 52,
    Result: "Siren Song Melamine Plates",
    Link: "https://fave.co/3kZqOk9",
    Price: "$68 (set of 4)",
    Retailer: "Food52",
    Category: "Camping",
    Description:
      "These plates are plastic—but they sure don't feel like it. Durable campfire flatware can be stylish, too (and it's more sustainable than using disposable.)",
    ImageURL:
      "https://assets.epicurious.com/photos/61982098cb910d4f24b3affd/1:1/pass/21_Epi_GG-Quiz-Art_sirensongebruprintmelamineplates_VOG.png",
  },
  {
    resultId: 51,
    Result: "Coleman Camp Oven",
    Link: "https://amzn.to/2ZcxyDH",
    Price: "$50",
    Retailer: "Amazon",
    Category: "Camping",
    Description:
      "This simple chamber heats by reflecting light from your campfire. Which means: If you can dream it, you can bake it.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820b7fa4849e9c2076173/1:1/pass/21_Epi_GG-Quiz-Art_colemean_campingoven_VOG.png",
  },
  {
    resultId: 50,
    Result: "Over Fire Frill Grate",
    Link: "https://amzn.to/3kYFy2M",
    Price: "$23",
    Retailer: "Amazon",
    Category: "Camping",
    Description:
      "This grate turns any campfire into a grill for vegetables, turkey dogs, or whatever you're cooking under the stars.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820b48c2b8551b4a4c77c/1:1/pass/21_Epi_GG-Quiz-Art_DZRZVD_Grate_VOG.png",
  },
  {
    resultId: 49,
    Result: "Solo",
    Link: "https://amzn.to/30TYh91",
    Price: "$13",
    Retailer: "Amazon",
    Category: "Entertaining",
    Description: result49Description(),
    ImageURL:
      "https://assets.epicurious.com/photos/6198209789f2fc538ca5b6b9/1:1/pass/21_Epi_GG-Quiz-Art_Solo_Anito_Lo_VOG.png",
  },
  {
    resultId: 48,
    Result: "One Tin Bakes",
    Link: "https://amzn.to/3r8WKq6",
    Price: "$16",
    Retailer: "Amazon",
    Category: "Baking",
    Description: result48Description(),
    ImageURL:
      "https://assets.epicurious.com/photos/6198209acb910d4f24b3afff/1:1/pass/21_Epi_GG-Quiz-Art_One_Tin_Bakes_VOG.png",
  },
  {
    resultId: 46,
    Result: "Celebrate with Kim-Joy",
    Link: "https://amzn.to/3qXZ1Ez",
    Price: "$27",
    Retailer: "Amazon",
    Category: "Baking",
    Description:
      "Great British Bake Off contestant Kim-Joy is beloved for her whimsical, intricate pastry and cake decorating. Give the baker in your life her book and they can recreate the magic, with her careful instruction, at home.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820ba54a31a5cf1e3da91/1:1/pass/21_Epi_GG-Quiz-Art_CelebratewithKimJoy_Cover_VOG.png",
  },
  {
    resultId: 45,
    Result: "5-Piece Deco Pen and Nozzle Set",
    Link: "https://amzn.to/3r1K1Wy",
    Price: "$29",
    Retailer: "Amazon",
    Category: "Baking",
    Description:
      "If the baker in your life is tired of messing with piping bags, give this compact pen, which is reusable and dishwasher-safe, and allows for precise frosting work.",
    ImageURL:
      "https://assets.epicurious.com/photos/6198209e46256f3a0a1d3d57/1:1/pass/21_Epi_GG-Quiz-Art_Lekuie_VOG.png",
  },
  {
    resultId: 44,
    Result: "Stoneware and Wood Lazy Susan",
    Link: "https://fave.co/3nEkXTk",
    Price: "$69",
    Retailer: "Pottery Barn",
    Category: "Baking/Entertaining",
    Description:
      "This lazy Susan works as a turntable for frosting cakes—and it's pretty enough to display them on, as well.",
    ImageURL:
      "https://assets.epicurious.com/photos/6198209dff65a2ed43249a6a/1:1/pass/21_Epi_GG-Quiz-Art_mason-stoneware-wood-lazy-susan-z_VOG.png",
  },
  {
    resultId: 43,
    Result: "Mason Cash In the Forest Mixing Bowls, 3-Piece Set",
    Link: "https://fave.co/3cAQjDW",
    Price: "$100",
    Retailer: "World Market",
    Category: "Baking",
    Description:
      "Mason Cash began as a small pottery studio in 1800s England, and its signature Cane design mixing bowls became more sought-out than ever before after getting so much camera time on GBBO. The patterned exterior of the earthenware bowl isn’t just about looks—it’s designed to help keep your hand steady when mixing. ",
    ImageURL:
      "https://assets.epicurious.com/photos/619820a2ecf2f96340426673/1:1/pass/21_Epi_GG-Quiz-Art_etsy_bowls_VOG.png",
  },
  {
    resultId: 42,
    Result: "Sourdough Crock",
    Link: "https://fave.co/3HJlgnQ",
    Price: "$60",
    Retailer: "Etsy",
    Category: "Baking",
    Description:
      "If the sourdough lover in your life keeps their starter in a quart container, give the gift of this pretty and practical upgrade. After all, the ingredient they feed and care for like a baby deserves a nice home.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820a27b3f5e4c0a803846/1:1/pass/21_Epi_GG-Quiz-Art_etsy_claypot_VOG.png",
  },
  {
    resultId: 41,
    Result: "Fellow Atmos Vacuum Canisters",
    Link: "https://amzn.to/3oNqk1W",
    Price: "$30",
    Retailer: "Amazon",
    Category: "Coffee",
    Description: result41Description(),
    ImageURL:
      "https://assets.epicurious.com/photos/619820bdd9d5577df6d665b8/1:1/pass/21_Epi_GG-Quiz-Art_Atmos-Hero-CG-L_VOG.png",
  },
  {
    resultId: 40,
    Result: "Bottomless Portafilter",
    Link: "https://amzn.to/32pR94E",
    Price: "$60",
    Retailer: "Amazon",
    Category: "Coffee",
    Description:
      "A bottomless portafilter is what it sounds like: a portafilter for your espresso machine that has the spout and bottom removed, exposing the basket that holds the ground coffee. It means no old water is sitting trapped between the basket and spout—and getting accidentally added to your espresso shot. It also allows users to watch the entire brewing process, allowing them to adjust dosing and tamping methods to better get their perfect brew.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820a3ff65a2ed43249a6c/1:1/pass/21_Epi_GG-Quiz-Art_espressohandle_VOG.png",
  },
  {
    resultId: 39,
    Result: "Breville Barista Express Espresso Machine",
    Link: "https://www.amazon.com/Breville-BES870XL-Barista-Express-Espresso/dp/B00CH9QWOU",
    Price: "$700",
    Retailer: "Amazon",
    Category: "Coffee",
    Description:
      "There's no competition in the under-$1,000 price bracket when it comes to espresso machines: The Breville pulls a smooth, rich shot, and is easy to operate, with a milk frother than produces velvety microfoam.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820bbfa4849e9c2076175/1:1/pass/21_Epi_GG-Quiz-Art_breville_espressomaker_VOG.png",
  },
  {
    resultId: 38,
    Result: "Cortado Cups",
    Link: "https://fave.co/3cJwfiN",
    Price: "$50/2 Cups",
    Retailer: "Ban.do",
    Category: "Coffee",
    Description:
      "If your favorite coffee aficionado likes a cortado, macchiato, or just a little splash of milk with their espresso, these cups are just right: not too small like espresso cups, not too big like a full coffee mug. And they look super modern and feel so nice to hold.",
    ImageURL:
      "https://assets.epicurious.com/photos/619e635f9fbb493824d482db/1:1/pass/DOUBLE-WALL%20AMBER%20GLASS%20SET.png",
  },
  {
    resultId: 37,
    Result: "Emmy Marble Server",
    Link: "https://fave.co/3p8bEus",
    Price: "$40",
    Retailer: "CB2",
    Category: "Entertaining",
    Description:
      "Give the ultimate dinner party host in your life the gift of a vibrant marble platter that's begging to have crudités served atop it. ",
    ImageURL:
      "https://assets.epicurious.com/photos/619e6364a04c4ac12073b16e/1:1/pass/emmy-green-marble-server.png",
  },
  {
    resultId: 35,
    Result: "Wine Bucket",
    Link: "https://fave.co/3nMQ0fN",
    Price: "$80",
    Retailer: "Webstaurant Store",
    Category: "Wine/Entertaining",
    Description:
      "This classically stylish Champagne bucket can be used to chill any bottle, including your crisp white wines and your crushable light reds. ",
    ImageURL:
      "https://assets.epicurious.com/photos/619820a589f2fc538ca5b6bb/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_SchottZwieselChampagneBucket_VOG.png",
  },
  {
    resultId: 34,
    Result: "Ippodo Matcha",
    Link: "https://amzn.to/3cAfS8h",
    Price: "$30",
    Retailer: "Amazon",
    Category: "Tea",
    Description:
      "You only need about a half teaspoon of this flavorful matcha to make a delicious cup, so this gift will last a good number of chilly mornings. The pretty packaging makes it a great stocking stuffer, or pair it with a chawan and scoop for a bigger gift.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820acff65a2ed43249a6e/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_IppodoTeaUmmon40g_VOG.png",
  },
  {
    resultId: 33,
    Result: "Belloq Tea Sampler",
    Link: "https://fave.co/3HWh8B9",
    Price: "$32",
    Retailer: "Food52",
    Category: "Tea",
    Description:
      "Every tea drinker will appreciate the opportunity to try new blends. This collection of Belloq's most popular teas comes in stylish, gift-friendly packaging. It contains a toasty, nutty breakfast tea and a soothing mint, among others.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820b2fa4849e9c2076171/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_BellocqTeaSampler_VOG.png",
  },
  {
    resultId: 32,
    Result: "Hasami Tea Pot",
    Link: "https://fave.co/30KDrIK",
    Price: "$78",
    Retailer: "Jinen",
    Category: "Tea",
    Description:
      "Take your tea to the table with this glossy, clean-lined porcelain tea pot from beloved pottery house Hasami. The pot is slim, which makes for easy storage, and it’s dishwasher- and microwave-safe.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820adff65a2ed43249a70/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_HasamiTeaPot_VOG.png",
  },
  {
    resultId: 31,
    Result: "Ripple Coupe Glass",
    Link: "https://fave.co/3l0NiBs",
    Price: "$55/2 glasses",
    Retailer: "Verishop",
    Category: "Cocktail",
    Description:
      "There's something about fluted glass that feels extra fancy. The host on your list will be excited to serve a bracing batch of martinis in these coupes. ",
    ImageURL:
      "https://assets.epicurious.com/photos/619820a5021ada8771c25b81/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_RippleCoupGlass_VOG.png",
  },
  {
    resultId: 30,
    Result: "JetBoil Flash Camping and Backpacking Stove",
    Link: "https://amzn.to/3HGFT3X",
    Price: "$110",
    Retailer: "Amazon",
    Category: "Camping",
    Description:
      "With this tool, you can have hot water for coffee (or whatever you're cooking) in 45 seconds. ",
    ImageURL:
      "https://assets.epicurious.com/photos/619820abecf2f96340426675/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_JetBoilZip_VOG.png",
  },
  {
    resultId: 29,
    Result: "Nesting Mess Gear",
    Link: "https://amzn.to/3CGVIDZ",
    Price: "$63",
    Retailer: "Amazon",
    Category: "Camping",
    Description:
      "A modular set of lightweight aluminum cookware means the camper you're shopping for can cook over the fire, without hauling heavy cast iron around. ",
    ImageURL:
      "https://assets.epicurious.com/photos/619820ba1eebb0da631b1799/1:1/pass/21_Epi_GG-Quiz-Art_CampingPotSet_VOG.png",
  },
  {
    resultId: 28,
    Result: "Trade Coffee Subscription",
    Link: "https://go.skimresources.com?id=100105X1555757&xs=1&url=https%3A%2F%2Fwww.drinktrade.com%2Fgift-subscription%2Fp%2F1858",
    Price: "$60/3 bags",
    Retailer: "Trade",
    Category: "Coffee",
    Description:
      "A great gift for the coffee lover who has everything, but always loves trying new beans. A Trade Coffee subscription lets them personalize the coffee selections to their taste—you fill out a quiz before ordering, including your level of coffee knowledge, preferred brewing method, and taste preferences. All coffee comes from small roasters and all beans are fair-trade.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820a41eebb0da631b178f/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_TradeCoffeeSubscription_VOG.png",
  },
  {
    resultId: 27,
    Result: "Tattersall Sour Cherry Liqueur",
    Link: "https://fave.co/3cHv2IL",
    Price: "$32",
    Retailer: "Total Wine",
    Category: "Cocktail",
    Description:
      "Once your favorite cocktail lover has all the basics, it's time to turn to the drinks with slightly more esoteric ingredients. Upgrade their next Blood & Sand with this bottling made with Michigan sour cherries",
    ImageURL:
      "https://assets.epicurious.com/photos/6198404446256f3a0a1d3d5d/1:1/pass/21_Epi_GG_Quiz_art_Tattersall_VOG.png",
  },
  {
    resultId: 26,
    Result: "Ki No Bi Navy Strength Gin",
    Link: "https://fave.co/3Fw3vXc",
    Price: "$85",
    Retailer: "Wine.com",
    Category: "Cocktail",
    Description:
      "This is the ultimate gift for the martini lover. Pair with a bottle of Oka Kura Japanese Bermutto for a truly luxurious drink setup.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820abedadb2ce5aa72964/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_KiNoBiNavyStrengthGin_VOG.png",
  },
  {
    resultId: 25,
    Result: "Victoria Cast-Iron Skillet",
    Link: "https://amzn.to/3cDAQ5Z",
    Price: "$30",
    Retailer: "Amazon",
    Category: "Camping",
    Description:
      "A cast-iron skillet is a sturdy, versatile classic that will last your favorite cook a lifetime",
    ImageURL:
      "https://assets.epicurious.com/photos/619820a47b3f5e4c0a803848/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_Victoria12inCastIronSkill_VOG.png",
  },
  {
    resultId: 24,
    Result: "Glasvin, The Expression SET OF 2",
    Link: "https://www.google.com/url?q=https://cna.st/p/2hc5hQAHzZW416XNwR5kpnGjCDPckoxxRULuxyrPwKLnn2d61tbAN7qzeLwH9avgBoFissHD9fC5JxUuLwRoFvW4usk3k3qENJy54rraDT7?cid%3D609eae7f6ffd2573e2a7c6d2%26xid%3Dfr1627921500286gjj&sa=D&source=editors&ust=1632778953986000&usg=AOvVaw33eXWNd9F7vEOHWXYd77YJ",
    Price: "$75/2 glasses",
    Retailer: "Parcelle",
    Category: "Wine/Entertaining",
    Description:
      "A solo dinner can feel even more special with a glass of something delicious—worthy of some really nice stemware, not the massive set they keep around for clumsy guests. ",
    ImageURL:
      "https://assets.epicurious.com/photos/619d115f6925a06248a5b0a4/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_Glasvin_VOG.png",
  },
  {
    resultId: 23,
    Result: "Mosser Glass Mugs, Set of 4",
    Link: "https://fave.co/3cAjkzB",
    Price: "$74",
    Retailer: "Food52",
    Category: "Coffee/Tea",
    Description:
      "Give these appealingly retro milk glass mugs to the coffee lover whose kitchen suits pastels. The mugs feel surprisingly durable and hefty in the hand, without sacrificing a delicate sipping experience.",
    ImageURL:
      "https://assets.epicurious.com/photos/6198209a54a31a5cf1e3da89/1:1/pass/21_Epi_GG-Quiz-Art_mossermugs_tout.png",
  },
  {
    resultId: 22,
    Result: "Gradient Glasses",
    Link: "https://fave.co/3CBSxgY",
    Price: "$45/glass ($180 for 4)",
    Retailer: "Coming Soon",
    Category: "Entertaining",
    Description:
      "Even drinking tap water feels fun and festive in these bright ombré glasses.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820ae021ada8771c25b85/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_GradientGlasses_VOG.png",
  },
  {
    resultId: 21,
    Result: "Opinel paring knife set",
    Link: "https://amzn.to/3nJ80aW",
    Price: "$28",
    Retailer: "Amazon",
    Category: "Entertaining",
    Description:
      "These stylish knives can be used for all manner of kitchen prep work, but they look especially great on a cheese board.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820a6edadb2ce5aa72962/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_OpinelParingKnife_VOG.png",
  },
  {
    resultId: 20,
    Result: "Bread lamé",
    Link: "https://amzn.to/3qX8vQB",
    Price: "$14",
    Retailer: "Amazon",
    Category: "Baking",
    Description:
      "Maybe the person you're shopping for has mastered sourdough—all but those beautiful scoring patterns and consistent ",
    ImageURL:
      "https://assets.epicurious.com/photos/619820beecf2f96340426679/1:1/pass/21_Epi_GG-Quiz-Art_bakerofseville_lame_VOG.png",
  },
  {
    resultId: 19,
    Result: "Spider",
    Link: "https://amzn.to/3CK9qG6",
    Price: "$19",
    Retailer: "Amazon",
    Category: "Cooking",
    Description:
      "Use this tool to fish fried foods out of hot oil, to grab blanched vegetables or poached eggs out of boiling water, or to grab meatballs out of simmering sauce. ",
    ImageURL:
      "https://assets.epicurious.com/photos/619820a851794f92483fe5b2/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_MVTraderCopperSkimmer_VOG.png",
  },
  {
    resultId: 18,
    Result: "Ooni Pizza Oven",
    Link: "https://fave.co/3FICCPN",
    Price: "$400",
    Retailer: "Ooni",
    Category: "Entertaining/Baking/Cooking",
    Description:
      "The splurge-worthy gift for the home cook who has everything—except their very own outdoor pizza oven. Because this person has probably also told you at least 12 times that you can’t get perfect crust from a conventional oven.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820a77b3f5e4c0a80384a/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_OoniPizzaOven_VOG.png",
  },
  {
    resultId: 17,
    Result: "All Clad Waffle Maker",
    Link: "https://amzn.to/3qXEd04",
    Price: "$200",
    Retailer: "Amazon",
    Category: "Cooking",
    Description:
      "The All-Clad Belgian Waffle Iron is the Cadillac of waffle makers—a hulking, shiny, stainless steel behemoth capable of turning out batch after batch of five-star hotel-buffet-quality waffles. ",
    ImageURL:
      "https://assets.epicurious.com/photos/619820b475d5cc622a8962ed/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_AllCladWaffleMaker_VOG.png",
  },
  {
    resultId: 16,
    Result: "Handmade Crinkle Edge Platter",
    Link: "https://fave.co/3xdvBmW",
    Price: "$130",
    Retailer: "Food52",
    Category: "Entertaining",
    Description:
      "This platter looks luxuriously thin and delicate, almost as if it's made of paper. The person you give it to will find a million uses for it: Roast birds, vegetable sides, and pretty desserts. ",
    ImageURL:
      "https://assets.epicurious.com/photos/619820adedadb2ce5aa72966/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_HandmadeCrinkleEdgePlatter_VOG.png",
  },
  {
    resultId: 15,
    Result: "Square Sided Salad Plates",
    Link: "https://fave.co/3CJ9Hck",
    Price: "$36/plate ($144 for 4)",
    Retailer: "Jono Pandolfi",
    Category: "Entertaining",
    Description:
      "These small plates are perfect for snacks, salads, and pieces of toast in the morning.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820aa1eebb0da631b1793/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_JonoPandolfiSquarePlates_VOG.png",
  },
  {
    resultId: 14,
    Result: "Oka Kura Japanese Bermutto",
    Link: "https://fave.co/3l7Jqi5",
    Price: "$30",
    Retailer: "Parcelle",
    Category: "Cocktail",
    Description:
      "When your favorite spritz lover is ready to move past Aperol, they'll happily open this fortified sake-based vermouth, which is flavored with yuzu and sansho pepper. A spritz with Bermutto is dry, herbal, citrusy, and slightly savory, perfect for pairing with salty snacks.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820a7fa4849e9c207616f/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_OkaKuraJapaneseBermutto_VOG.png",
  },
  {
    resultId: 12,
    Result: "Demitasse Spoons",
    Link: "https://fave.co/3CFKS19",
    Price: "$34",
    Retailer: "Hawkins",
    Category: "Coffee",
    Description:
      "Demitasse spoons, which measure around 4½ inches long, can be placed on a coaster next to a shot of espresso for stirring in sugar or milk. You can also dip them into a pot or a bowl for a taste test as you cook, or use them to spoon things like curry paste or honey out of the always-too-small-for-a-normal-spoon jars they come in.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820ac1eebb0da631b1795/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_HawkinsDemitasseSpoons_VOG.png",
  },
  {
    resultId: 11,
    Result: "Carter Everywhere Mug",
    Link: "https://fave.co/3r15UFp",
    Price: "$30",
    Retailer: "Fellow",
    Category: "Tea/Coffee",
    Description:
      "This sleek little to-go mug is the perfect gift for keeping coffee hot (or booze cold) on a camping trip, or for anyone taking their morning brew back on the road as they get into an office routine again. ",
    ImageURL:
      "https://assets.epicurious.com/photos/619820b0aece33a8e0f84458/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_FellowCarterEverywhereMug_VOG.png",
  },
  {
    resultId: 10,
    Result: "Bellocq Tea Strainers, Set of 2",
    Link: "https://fave.co/3cBpob6",
    Price: "$44",
    Retailer: "Food52",
    Category: "Tea",
    Description:
      "These are not your average tea strainers: They're hand made of brass by metal forgers and will look absolutely stunning perched on your cup. The smaller model sits atop your teacup, and a larger model fits in a teapot.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820b2dbc20a67736dd035/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_BellocqTeaSTrainers_VOG.png",
  },
  {
    resultId: 9,
    Result: "Taiwanese Tea Gift Set ",
    Link: "https://fave.co/3DJ8EL3",
    Price: "$110",
    Retailer: "Food52",
    Category: "Tea",
    Description:
      "Every full-leaf tea in this highly giftable box is sourced from Taiwanese farms: The box contains formosa, Taiwanese oolong, and High Mountain. It's a splurge, sure, but it's also a beautiful entry point into the world of Taiwanese teas. ",
    ImageURL:
      "https://assets.epicurious.com/photos/619820a51eebb0da631b1791/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_TaiwaneseTeaGift_VOG.png",
  },
  {
    resultId: 8,
    Result: "Fellow Coffee Grinder",
    Link: "https://fave.co/3DKJwDu",
    Price: "$300",
    Retailer: "Nordstrom",
    Category: "Coffee",
    Description:
      "This sleek,  minimalist grinder is the perfect gift for the coffee lover who has everything, but would appreciate a gadget update. It grinds with pro-grade 64 millimeter flat burrs and leaves no bean behind, giving you consistent grinds for drip and pourover coffee. ",
    ImageURL:
      "https://assets.epicurious.com/photos/619820af75d5cc622a8962eb/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_FellowCoffeeGrinder_VOG.png",
  },
  {
    resultId: 7,
    Result: "Danish Dough Whisk",
    Link: "https://amzn.to/3DDZ2RH",
    Price: "$13",
    Retailer: "Amazon",
    Category: "Baking",
    Description:
      "The Danish dough whisk really goes beyond what a typical whisk can do; it has the power to work through tough, flour-based mixtures.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820ab89f2fc538ca5b6bd/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_JillmoDanishDoughWhisk_VOG.png",
  },
  {
    resultId: 6,
    Result: "Atelier Saucier Cocktail Napkins",
    Link: "https://fave.co/3nJR7gh",
    Price: "$32",
    Retailer: "West Elm",
    Category: "Cocktail/Entertaining",
    Description:
      "No more paper cocktail napkins. These reusable numbers, made of recycled textiles, add a pop of color and playfulness to any table, thanks to their rainbow-edged embroidery.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820b4aece33a8e0f8445a/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_AtelierSaucierNapkins_VOG.png",
  },
  {
    resultId: 5,
    Result: "Victorinox Pro Serrated Chef's Knife",
    Link: "https://amzn.to/2Zcq2Zt",
    Price: "$20",
    Retailer: "Amazon",
    Category: "Baking",
    Description:
      "This Victorinox knife is great for slicing particularly thick, crusty loaves of bread—and it's more versatile than your typical serrated knife.",
    ImageURL:
      "https://assets.epicurious.com/photos/61a655d7bb050c23990e2b52/1:1/pass/21_Epi_GG_Quiz_art_VictorinoxSerrated_VOG_final.jpg",
  },
  {
    resultId: 4,
    Result: "Bean Envy Milk Frother",
    Link: "https://amzn.to/3cA8FoH",
    Price: "$15",
    Retailer: "Amazon",
    Category: "Coffee",
    Description:
      "This tool transforms a serviceable cup of coffee into the sort of cozy brew—piping hot, balanced, and finished with a blanket of sweet, soft, fine-grained foam on top—that you'd drop five bucks on at a fancy coffee shop.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820bcaece33a8e0f8445c/1:1/pass/21_Epi_GG-Quiz-Art_Black_frother_stack_1_R2_VOG.png",
  },
  {
    resultId: 2,
    Result: "Doña Rosa x Masienda Tortilla Press",
    Link: "https://fave.co/3oVh5fW",
    Price: "$98",
    Retailer: "Masienda",
    Category: "Entertaining",
    Description: result2Description(),
    ImageURL:
      "https://assets.epicurious.com/photos/619820a875d5cc622a8962e7/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_MasiendaTortillasPress_VOG.png",
  },
  {
    resultId: 1,
    Result: "Mac Chef's Knife",
    Link: "https://amzn.to/3FBK27u",
    Price: "$145",
    Retailer: "Amazon",
    Category: "Cooking",
    Description:
      "Receiving our all-time favorite chef's knife is the first step in the delicate, precise knifework that will elevate every recipe your favorite home cook makes.",
    ImageURL:
      "https://assets.epicurious.com/photos/619820a951794f92483fe5b4/1:1/pass/21_Epi_GG-Quiz-Art_Epi_GGQA_MacKnifeMTH80_VOG.png",
  },
]
